module.exports = __webpack_public_path__ + "img/logo@2x.b187d5c0.png";